import Vue from 'vue';
import components from './lib';

Object.keys(components).forEach(component => {
    Vue.component(component, {
        extends: components[component],
    });
});
